import { SETTINGS_TABLE_TOOLBAR_CLASS } from "@/pages/settings/settings-layout-constants";
import type { ReactNode } from "react";

export function SettingsTableToolbar({ children }: { children: ReactNode }) {
  return (
    <div className={SETTINGS_TABLE_TOOLBAR_CLASS}>
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">{children}</div>
    </div>
  );
}
